import { FC } from 'react';
import SelectTab from '../SelectTab';
import SearchFormItem from './subpage/searchFormItem';
import { getSelectPlaceholder } from '../utils/ruleUtils';
import { SelectTabProps } from '../SelectTab/interface';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';

export interface SearchFormSelectTabProps extends BaseSearchFormItemProps {
  /** SelectTab Props */
  selectTabProps?: SelectTabProps;
}
/** 分tabs下拉选择框 */
export const SearchFormSelectTab: FC<SearchFormSelectTabProps> = props => {
  const {
    selectTabProps,
    isDetail,
    form,
    isTable,
    name,
    testId,
    label,
    rules,
    copy,
    ...resProps
  } = props;
  return (
    <SearchFormItem
      {...resProps}
      disabled={isDetail || selectTabProps?.disabled}
      name={name}
      label={label}
      rules={rules}
      validateTrigger="onChange"
    >
      <SelectTab
        allowClear
        showSearch
        test-id={`${testId}-${name}`}
        {...selectTabProps}
        disabled={isDetail || selectTabProps?.disabled}
        placeholder={getSelectPlaceholder(label, selectTabProps, rules)}
      />
    </SearchFormItem>
  );
};

SearchFormSelectTab.displayName = SearchFormItemEnum.SearchFormSelectTab;

export default SearchFormSelectTab;
